import httpService from '@/services/httpService'
import { convertAdvancedOptionsToURLParams } from '@/store/modules/rank-zone/Helper'
import _ from 'lodash'

export const types = {
    SET_SELLER_CHART_DATA: 'product-grid-report/SET_SELLER_CHART_DATA',
    SET_SELLER_TABLE_DATA: 'product-grid-report/SET_SELLER_TABLE_DATA',
    SET_CLIENT_SHOP: 'product-grid-report/SET_CLIENT_SHOP',
    SET_COMPETITOR_SHOPS: 'product-grid-report/SET_COMPETITOR_SHOPS',
    SET_KEYWORD_CHART_DATA: 'product-grid-report/SET_KEYWORD_CHART_DATA',
    SET_KEYWORD_TABLE_DATA: 'product-grid-report/SET_KEYWORD_TABLE_DATA',
}

const state = {
    sellerChartData: {},
    sellerTableData: {},
    clientShop: '',
    competitorShops: [],
    keywordChartData: {},
    keywordTableData: [],
}

const mutations = {
    [types.SET_SELLER_CHART_DATA]: function (state, data) {
        state.sellerChartData = data;
    },
    [types.SET_SELLER_TABLE_DATA]: function (state, { data, snapshot_date }) {
        state.sellerTableData[snapshot_date] = data;
    },
    [types.SET_CLIENT_SHOP]: function (state, data) {
        state.clientShop = data;
    },
    [types.SET_COMPETITOR_SHOPS]: function (state, data) {
        state.competitorShops = data;
    },
    [types.SET_KEYWORD_CHART_DATA]: function (state, data) {
        state.keywordChartData = data;
    },
    [types.SET_KEYWORD_TABLE_DATA]: function (state, data) {
        state.keywordTableData = data;
    }
}

const actions = {
    getSellersList: async function ({ commit }, { clientId, filters }) {
        const response = await httpService.get(`/reports/product-grid/sellers/${clientId}`, { params: filters });

        if (!response || !response.data) {
            return;
        }

        commit(types.SET_CLIENT_SHOP, response.data.client_shop);
        commit(types.SET_COMPETITOR_SHOPS, response.data.competitor_shops);
    },
    getSellerChartData: async function ({ commit }, { clientId, filters }) {
        const response = await httpService.get(`/reports/product-grid/seller/chart/${clientId}`, { 
            params: { filters: JSON.stringify(filters) }
        });

        if (!response || !response.data) {
            return;
        }

        commit(types.SET_SELLER_CHART_DATA, response.data);
    },
    getSellerTableData: async function ({ commit }, { clientId, filters }) {
        const response = await httpService.get(`/reports/product-grid/seller/table/${clientId}`, { 
            params: { 
                filters: JSON.stringify(filters),
                snapshot_date: filters.snapshot_date
            }
        });

        if (!response || !response.data) {
            return;
        }

        commit(types.SET_SELLER_TABLE_DATA, {
            data: response.data,
            snapshot_date: filters.snapshot_date
        });
    },
    getKeywordsTableData: async function ({ commit }, { clientId, filters }) {
        const response = await httpService.get(`/reports/product-grid/keywords/table/${clientId}`, { 
            params: { 
                filters: JSON.stringify(filters),
                snapshot_date: filters.snapshot_date
            }
        });

        commit(types.SET_KEYWORD_TABLE_DATA, response.data);
        
    },
    getKeywordsChartData: async function ({ commit }, { clientId, filters }) {
        const response = await httpService.get(`/reports/product-grid/keywords/chart/${clientId}`, { 
            params: { 
                filters: JSON.stringify(filters),
                snapshot_date: filters.snapshot_date
            }
        });

        commit(types.SET_KEYWORD_CHART_DATA, response.data);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
} 